import { isNil } from "@grandvisionhq/utils";
const prescriptionDictionary = {
  addition: "addition",
  axisInt: "axis",
  // axis is returned as axisInt from the prescription query, but should be sent as axis to cart (and therefore in state)
  baseCurve: "baseCurve",
  cylinder: "cylinder",
  diameter: "diameter",
  power: "power",
  pupillaryDistance: "pupillaryDistance"
};
const mapPrescriptionRecognitionValuesToState = (prescriptionValues) => {
  const result = Object.entries(prescriptionValues).reduce((values, [key, value]) => {
    if (!isNil(value) && prescriptionDictionary[key]) {
      values[prescriptionDictionary[key]] = value;
    }
    return values;
  }, {});
  return result;
};
export {
  mapPrescriptionRecognitionValuesToState
};
//# sourceMappingURL=map-prescription-recognition-values-to-state.js.map
